<template>
  <div style="width: 100%;height: 100%">
    <div style="margin-left: 20px;position: relative;height: 100%">
      <div style="height: 40px">
        <div style="float: left;color: #1a1a1a;font-size: 24px;"><strong>{{bookName}}</strong></div>
        <el-button class="save-button" style="float: right" @click="exportExcel">导出</el-button>
        <el-button class="save-button" style="float: right;margin-right: 10px" @click="generateAuthCode">生成激活码</el-button>
      </div>
      <div style="height: calc(100% - 110px);margin-top: 20px">
        <el-table id="authCodeTable" class="handle-list" v-loading="tableLoading" element-loading-text="加载中，请耐心等待。" element-loading-spinner="el-icon-loading"
                  :data="tableData" border height="100%">
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center">
          </el-table-column>
          <el-table-column
            prop="code"
            label="激活码"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            label="激活状态"
            min-width="70"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.activation === 0 ? '未激活' : '已激活'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="激活手机号"
            min-width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="activationTime"
            label="激活时间"
            min-width="100"
            align="center">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            min-width="100"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="70"  class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <button class="my-btn" style="color: #ff6666;padding: 0 5px" @click="delAuthCode(scope.row)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination class="page-style" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="生成激活码" :visible.sync="generateAuthCodeShow" v-if="generateAuthCodeShow" width="700px" :show-close="true" :close-on-click-modal="false" center>
      <add-auth-code v-model="generateAuthCodeShow" :bookObj="bookObj" @getFatherAuthCode="getFatherAuthCode"></add-auth-code>
    </el-dialog>
  </div>
</template>

<script>
import {delAuthCode, getAuthCodeListByBook} from '../../api/authCode'
import addAuthCode from './addAuthCode'

export default {
  name: 'seeAuthCode',
  components: {addAuthCode},
  model: {
    prop: 'seeAuthCodeShow',
    event: 'change'
  },
  data () {
    return {
      tableLoading: false,
      bookName: '',
      seeAuthCodeObj: '',
      tableData: [],

      pageSize: 10,
      currentPage: 1,
      totalCells: 0,

      generateAuthCodeShow: false,
      bookObj: ''
    }
  },
  methods: {
    getInitData (obj) {
      this.seeAuthCodeObj = obj
      this.bookName = obj.row.name
      this.getAuthCodeList()
    },
    getAuthCodeList () {
      this.tableLoading = true
      let body = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        bookId: this.seeAuthCodeObj.row.id
      }
      getAuthCodeListByBook(body).then(res => {
        this.tableLoading = false
        this.totalCells = res.data.totalCnt
        this.tableData = res.data.array
      })
    },
    delAuthCode (item) {
      this.$confirm('此操作将永久删除该激活码【' + item.code + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        delAuthCode(item.id).then(res => {
          this.$message({
            message: '成功删除章节',
            type: 'success'
          })
          this.getAuthCodeList()
        })
      })
    },
    generateAuthCode () {
      this.bookObj = this.seeAuthCodeObj
      this.generateAuthCodeShow = true
    },
    getFatherAuthCode () {
      this.getAuthCodeList()
    },
    exportExcel () {
      let arr = this.tableData
      import('../../vendor/Export2Excel').then(excel => {
        // dateTime name objType
        const tHeader = ['激活码', '激活状态', '激活手机号', '激活时间', '创建时间']
        const list = arr
        const data = this.formatExcelData(list)
        // console.log(data)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.bookName + '_激活码'
        })
      })
    },
    formatExcelData (list) {
      let arr = []
      list.forEach(function (item) {
        let obj = []
        obj.push(item.code)
        obj.push(item.activation === 0 ? '未激活' : '已激活')
        obj.push(item.phone)
        obj.push(item.activationTime)
        obj.push(item.createTime)
        arr.push(obj)
      })
      return arr
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.getAuthCodeList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getAuthCodeList()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/materialManagement/seeAuthCode.vue